import * as m from "mithril";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import './ScrollToTop.scss';
interface Attrs {
}
export function ScrollToTop(): m.Component<Attrs> {
  
    let lastScrollTop = 0;
  let hasHitBottom = false;
  let isVisible = false;
  
  // Keep track of the active scrolling container and the hide timer
  let activeScrollingElement: HTMLElement | null = null;
  let hideTimeoutId: number | null = null;

  const startHideTimer = () => {
    // Clear any previous countdown so it doesn't close prematurely
    if (hideTimeoutId) {
      window.clearTimeout(hideTimeoutId);
    }

    // Set a new timer to hide the button after 2000ms (2 seconds)
    hideTimeoutId = window.setTimeout(() => {
      if (isVisible) {
        isVisible = false;
        m.redraw(); // Force view update to fade out
      }
    }, 1500);
  };

  const handleScroll = (event: Event) => {
    const el = event.target as HTMLElement;
    if (!el || typeof el.scrollTop !== 'number') return;

    activeScrollingElement = el;

    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    const scrollHeight = el.scrollHeight;

    const bottomThreshold = 50;
    const isAtBottom = (clientHeight + scrollTop) >= (scrollHeight - bottomThreshold);

    if (isAtBottom) {
      hasHitBottom = true;
    }

    if (scrollTop <= 30) {
      hasHitBottom = false;
      if (isVisible) {
        isVisible = false;
        if (hideTimeoutId) window.clearTimeout(hideTimeoutId);
        m.redraw();
      }
    }

    // Visibility Condition: Must have reached bottom, and currently moving upwards
    const shouldBeVisible = hasHitBottom && scrollTop < lastScrollTop;

    if (shouldBeVisible) {
      if (!isVisible) {
        isVisible = true;
        m.redraw();
      }
      // Keep resetting the timer as long as they are actively scrolling up
      startHideTimer();
    } else if (!shouldBeVisible && isVisible && scrollTop > lastScrollTop) {
      // If they immediately start scrolling down again, hide right away
      isVisible = false;
      if (hideTimeoutId) window.clearTimeout(hideTimeoutId);
      m.redraw();
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  };

  const scrollToTop = () => {
    const scroller = activeScrollingElement || document.scrollingElement || document.documentElement;
    
    scroller.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Clean up all states and timers immediately upon user action
    hasHitBottom = false;
    isVisible = false;
    if (hideTimeoutId) {
      window.clearTimeout(hideTimeoutId);
    }
    m.redraw();
  };

  return {
    oncreate: () => {
      window.addEventListener('scroll', handleScroll, true);
    },
    onremove: () => {
      window.removeEventListener('scroll', handleScroll, true);
      // Safety cleanup if the component gets destroyed while a timer runs
      if (hideTimeoutId) window.clearTimeout(hideTimeoutId);
    },
    view: () => {
      return m('button', {
        class: `scroll-to-top ${isVisible ? 'is-visible' : ''}`,
        style: {
          position: 'fixed',
          bottom: '2rem',
          right: '2rem',
          zIndex: '999999',
        },
        onclick: scrollToTop,
        type: 'button',
        'aria-label': 'Scroll to top'
      }, [
        m('svg', {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '24',
          height: '24',
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': '2.5',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round'
        }, [
          m('path', { d: 'm18 15-6-6-6 6' })
        ])
      ]);
    }
  };
};